export default __webpack_public_path__ + "static/media/orange-candy.3580b106.png";